<script>
</script>

<footer>
    <div class="row">
        <a href = "mailto: contact@rathk.com" class="email">contact@rathk.com</a><br>
        <span class="copyright">Copyright © 2022 本網站與香港特別行政區政府無關 This website is not affiliated with the government of HKSAR</span>
    </div>
</footer>

<style>
    footer {
        width: 100vw;
        background-color: var(--cds-ui-03);
    }

    .row {
        padding-left: 50px;
        padding-top: 20px;
        padding-bottom: 20px;
        max-width: 780px;
        margin: 0 auto;
    }

    span {
        font-size: var(--cds-body-long-01-font-size, 0.875rem);
        color: var(--cds-text-01);
    }

    a {
        font-size: var(--cds-body-long-01-font-size, 0.875rem);
        color: var(--cds-text-01);
    }

</style>
